var form_submitting = false;
var set_form_submitting = function( ) { form_submitting = true; };

// Whole-dollar mask for investor amounts; shared with the investor list modals, which are
// loaded over AJAX after this file's ready handler has run.
//
// The mask keeps digits only, so it would silently rewrite any stored amount it cannot
// represent: '-500' becomes ',500' and '(1,234.56)' becomes ',123,456', which
// Investor.parse_amount can no longer read once saved. Those values -- negatives,
// accounting-style negatives, ambiguous groupings like '1.234.567' -- are left unmasked and
// verbatim for Investor.parse_amount to read server side. Plain non-negative amounts are
// floored to whole dollars first; masked as-is, '1234.56' would become '123,456'.
$.fn.bscDollarMask = function( ) {
  return this.each( function( ) {
    var $el = $( this );
    var candidate = ( $el.val( ) || '' ).toString( ).trim( ).replace( /[$,\s]/g, '' );

    if( candidate !== '' ) {
      if( ! /^\d+(\.\d+)?([eE][+-]?\d+)?$/.test( candidate ) ) {
        return;
      }

      $el.val( String( Math.floor( parseFloat( candidate ) ) ) );
    }

    $el.mask( '000,000,000,000,000,000,000', { reverse: true } );
  });
};

$( document ).ready( function( ) {
  // setup custom, attractive file upload widget, as per http://webapplayers.com/inspinia_admin-v2.9.3/ls_skin/form_file_upload.html
  $( '.custom-file-input' ).on( 'change', function( ) {
    let fileName = $( this ).val( ).split( '\\' ).pop( );
    $( this ).next( '.custom-file-label' ).addClass( 'selected' ).html( fileName );
  });

  $("[rel='tooltip']").tooltip();

  $( '.datepicker' ).datepicker({
    format: 'yyyy-mm-dd',
    todayBtn: 'linked',
    autoclose: true,
    todayHighlight: true,
  });

  $( '.selectize' ).selectize({ });

  $( '.best_in_place' ).best_in_place( );

  $( '.bsc-dollar-mask' ).bscDollarMask( );
  $( '.bsc-dollar-cents-mask' ).mask( '000,000,000,000,000,000,000.00', { reverse: true })


  var form_has_changed = false;

  $( 'form[data-form-warning-unsaved=true]' ).each( ( i, form ) => {
    $( form ).submit( set_form_submitting );
  });

  $( 'form[data-form-warning-unsaved=true] :input' ).change( function( ) {
    form_has_changed = true;
  });

  window.addEventListener( 'beforeunload', function( e ) {
    if( form_submitting || ! form_has_changed ) {
      return undefined;
    }

    var confirmation_message = 'You have made changes to the form that have not been saved';

    ( e || window.event ).returnValue = confirmation_message;
    return confirmation_message;
  });
});
